import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArchiveBox = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.9 6.6V13.8C3.9 14.1183 4.02643 14.4235 4.25147 14.6485C4.47652 14.8736 4.78174 15 5.1 15H12.9C13.0576 15 13.2136 14.969 13.3592 14.9087C13.5048 14.8483 13.6371 14.76 13.7485 14.6485C13.86 14.5371 13.9483 14.4048 14.0087 14.2592C14.069 14.1136 14.1 13.9576 14.1 13.8V6.6M7.35 9.3H10.65M2.7 4.2H15.3V6.6H2.7V4.2Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArchiveBox;
